const newLocal = 'CREATE_MESSAGE'
export default (state =[{'message':["info",""]}], action) => {
    switch (action.type) {
      case newLocal:
          return action.message
      default:
          return state
    }
  }